module.exports = __webpack_public_path__ + "media/country_flags/lr-d8dd5e0c.png";